import type { CreateSixStep } from '@/types/create-six.types';

export { resolveWizardStepStatus } from '@/utils/wizard.utils';

export type CreateSixWizardStepKey = 'Basics' | 'Owners' | 'Members' | 'External' | 'Review';

export interface CreateSixWizardStepMeta {
  stepNumber: number;
  label: CreateSixWizardStepKey;
}

export const CREATE_SIX_WIZARD_STEPS: CreateSixWizardStepMeta[] = [
  { stepNumber: 1, label: 'Basics' },
  { stepNumber: 2, label: 'Owners' },
  { stepNumber: 3, label: 'Members' },
  { stepNumber: 4, label: 'External' },
  { stepNumber: 5, label: 'Review' },
];

const CREATE_SIX_STEP_NUMBER_MAP = new Map<CreateSixStep, number>(
  CREATE_SIX_WIZARD_STEPS.map((step) => [step.label, step.stepNumber]),
);

export function resolveWizardStepNumber(createSixStep: CreateSixStep): number {
  return CREATE_SIX_STEP_NUMBER_MAP.get(createSixStep)
    ?? CREATE_SIX_WIZARD_STEPS[CREATE_SIX_WIZARD_STEPS.length - 1].stepNumber;
}
